"use client";

import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  fetchOrganizationRankings,
  type OrganizationRanking,
  type OrganizationRankingSortBy,
} from "@/entities/organization/api/organizations";
import type { PaginatedResponse } from "@/shared/api/common";
import type { OrganizationRegion } from "@/shared/config/constants";

const FIVE_MINUTES = 5 * 60 * 1000;

export function useOrganizationRankingsQuery(params: {
  region?: OrganizationRegion;
  paymentPercentage?: number;
  sortBy?: OrganizationRankingSortBy;
  page: number;
  limit: number;
  initialData?: PaginatedResponse<OrganizationRanking>;
}) {
  const { region, paymentPercentage, sortBy = "overall", page, limit } = params;

  return useQuery({
    queryKey: ["analytics", "organization-rankings", region ?? "all", paymentPercentage ?? 100, sortBy, page, limit],
    staleTime: FIVE_MINUTES,
    initialData:
      !region && (paymentPercentage ?? 100) === 100 && sortBy === "overall" && page === 1 && limit === 20
        ? params.initialData
        : undefined,
    placeholderData: keepPreviousData,
    queryFn: () =>
      fetchOrganizationRankings({
        region,
        payment_percentage: paymentPercentage,
        sort_by: sortBy,
        page,
        limit,
      }),
  });
}
